import React from 'react';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const TermAndConditionsPage: React.FC = () => {
  useDocumentTitle('Namasteji Manikchand - Terms & Conditions');

  return (
    <section className='w-full bg-white text-[#333] font-sans'>
      {/* Section Header */}
      <section
        className='py-3 sm:py-3 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'
        style={{
          borderBottom: '1px solid',
          borderTop: '1px solid',
          borderImageSource:
            'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
          borderImageSlice: 1,
        }}
      >
        <h2 className='font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
          TERMS & CONDITIONS
        </h2>

        {/* Decorative Image */}
        <div className='flex justify-center my-0 sm:my-0 md:my-6 lg:my-6 mb-3 sm:mb-3 md:mb-12 lg:mb-12'>
          <img
            src={aboutImage}
            alt='Decorative Line'
            className='max-w-[70%] sm:max-w-[50%] md:max-w-[50%] lg:max-w-[50%] h-auto'
          />
        </div>

        {/* Content Section */}
        <div className='max-w-6xl mx-auto text-sm sm:text-base md:text-base text-left text-gray-800 space-y-2 sm:space-y-2 md:space-y-6 lg:space-y-6 leading-relaxed'>
          {/* Section 1 */}
          <div>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
              Welcome to the official website of Namasteji Manikchand. By accessing or using this website, you agree to
              comply with the following Terms & Conditions. If you do not agree, we advise you to discontinue using this
              website.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
              1. Website Usage
            </h4>
            {/* <br /> */}
            <ol className='list-disc pl-5 space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-start'>
              <li className='text-justify'>You agree to use this website only for lawful purposes.</li>
              <li className='text-justify'>
                Content is intended for personal, non-commercial use unless expressly permitted.
              </li>
              <li className='text-justify'>Users must not attempt to disrupt or damage the website in any manner.</li>
            </ol>
          </div>

          {/* Section 3 */}
          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
              2. Intellectual Property
            </h4>
            <ol className='list-disc pl-5 space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-start'>
              <li className='text-justify'>
                All logos, text, graphics, and content are the intellectual property of{' '}
                <strong>Namasteji Manikchand.</strong>
              </li>
              <li className='text-justify'>
                Reproduction, modification, or distribution of any material without written consent is strictly
                prohibited.
              </li>
            </ol>
          </div>

          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
              3. Accuracy of Information
            </h4>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
              We strive to maintain accurate and updated information on our website; however, Namasteji Manikchand does
              not warrant that all details are free from error or omission.
            </p>
          </div>

          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3'>
              4. Limitation of Liability
            </h4>
            <ol className='list-disc pl-5 space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-start'>
              <li className='text-justify'>
                Namasteji Manikchand is not liable for any damages arising out of access, use, or inability to use this
                website.
              </li>
              <li className='text-justify'>
                Users are responsible for ensuring their devices are protected from malware, viruses, or harmful
                components
              </li>
            </ol>
          </div>

          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3'>
              5. External Links
            </h4>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
              Our website may provide links to third-party websites for additional resources.{' '}
              <strong>Namasteji Manikchand</strong> is not responsible for their content, practices, or policies
            </p>
          </div>

          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3'>
              6. Modifications
            </h4>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
              <strong>Namasteji Manikchand</strong> reserves the right to amend these Terms & Conditions at any time.
              Changes will be posted on this page and are effective immediately.
            </p>
          </div>

          <div>
            <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold space-y-1 sm:space-y-1 md:space-y-3 lg:space-y-3'>
              7. Governing Law
            </h4>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify mb-2'>
              These Terms & Conditions are governed by the laws of India, and disputes shall be subject to the exclusive
              jurisdiction of the courts in India
            </p>
          </div>
        </div>
      </section>
    </section>
  );
};

export default TermAndConditionsPage;
